import {
  bodyByteLength,
  PERSONAL_TODOS_BODY_HARD_CAP_BYTES
} from './models/personalTodos';

export type PersonalTodoEditFocusField = 'title' | 'body' | null;

export function modEnterLabel(): string {
  return /Mac|iPhone|iPad|iPod/.test(navigator.platform) ? '⌘Enter' : 'Ctrl+Enter';
}

export function personalTodoSaveHint(opts: {
  dirty: boolean;
  savedFlash: boolean;
  bodyDraft: string;
  focusField: PersonalTodoEditFocusField;
}): string {
  const { dirty, savedFlash, bodyDraft, focusField } = opts;

  if (bodyByteLength(bodyDraft) >= PERSONAL_TODOS_BODY_HARD_CAP_BYTES) {
    return 'Exceeds 16 KiB — trim to save';
  }
  if (savedFlash && !dirty) {
    return 'Saved · just now';
  }
  if (!dirty) {
    return '';
  }

  const modEnter = modEnterLabel();
  if (focusField === 'title') {
    return 'Unsaved changes · Enter to save';
  }
  if (focusField === 'body') {
    return `Unsaved changes · ${modEnter} to save`;
  }
  return `Unsaved changes · Enter in title · ${modEnter} in body`;
}
